import { union } from 'lodash-es';
import { deepExtendObject } from './deep-extend-object';

const CONNECT_TYPES_MAP = {
  facebook: 'facebook_disabled',
  google: 'google_disabled',
  twitter: 'twitter_disabled',
  email: 'email_disabled',
  disqus: 'disqus_disabled',
  microsoft: 'microsoft_disabled'
};

function singleMap(srcData, mapping) {
  let destData = null;
  if (isArray(srcData)) {
    destData = mapArray(srcData, mapping);
  } else if (isObject(srcData)) {
    destData = mapObject(srcData, mapping);
  }
  return destData;
}

function map(srcData) {
  if (arguments.length === 2) {
    return singleMap(srcData, arguments[1]);
  } else if (arguments.length > 2) {
    var mappings = [];
    for (let i = 1; i < arguments.length; i++) {
      mappings.push(arguments[i]);
    }
    return Object.assign({}, ...mappings.map(mapping => singleMap(srcData, mapping)));
  } else {
    return null;
  }
}

function mapArray(srcArr, mappings) {
  return srcArr.map(function (srcData) {
    return map(srcData, mappings);
  });
}

function mapObject(srcObj, mappings) {
  var destObj = {};

  if (isFunction(mappings)) {
    mappings = mappings();
  }

  if (isObject(mappings)) {
    Object.keys(mappings).forEach(function (srcKey) {
      // Skip mapping root
      if (srcKey === '~') {
        return;
      }

      var destKey = mappings[srcKey];
      var value = getValue(srcObj, srcKey);

      if (value === undefined) {
        return;
      }

      if (isString(destKey)) {
        setValue(destObj, destKey, value);
      } else {
        if (isFunction(destKey)) {
          destKey = destKey();
        }

        if (isObject(destKey)) {
          let root = destKey['~'];
          if (isArray(value)) {
            if (!root) {
              throw 'Error: destination mapping root for ' + srcKey + ' is missing.';
            }

            value = mapArray(value, destKey);
            setValue(destObj, root, value);
          } else {
            if (root) {
              throw 'Error: ' + srcKey + ' value expected to be an array.';
            }
            destObj = deepExtendObject(destObj, mapObject(value, destKey));
          }
        }
      }
    });
  }
  return destObj;
}

function setValue(obj, key, value) {
  var parts = key.split('.'),
    current = obj,
    lastPart = parts[parts.length - 1],
    part,
    arrayCheck;

  for (var i = 0; i < parts.length - 1; i++) {
    part = parts[i];
    arrayCheck = arrayKeyCheck(part);

    if (arrayCheck.isArray) {
      current = resolveArrayKey(current, arrayCheck.key);
      current = resolveObjectKey(current, arrayCheck.index);
    } else {
      current = resolveObjectKey(current, part);
    }
  }

  arrayCheck = arrayKeyCheck(lastPart);
  if (arrayCheck.isArray) {
    if (!current[arrayCheck.key]) {
      current[arrayCheck.key] = [];
    }
    current[arrayCheck.key][arrayCheck.index] = value;
  } else {
    current[lastPart] = value;
  }
}

function getValue(obj, key) {
  var parts = key.split('.'),
    value = obj,
    part,
    arrayCheck;

  for (var i = 0; i < parts.length && value; i++) {
    part = parts[i];
    arrayCheck = arrayKeyCheck(part);

    if (arrayCheck.isArray) {
      value = value[arrayCheck.key][arrayCheck.index];
    } else {
      value = value[part];
    }
  }

  // In case we didn't resolve the value because of null object, set value
  // to undefined
  if (i !== parts.length) {
    value = undefined;
  }

  return value;
}

function resolveObjectKey(obj, key) {
  return resolveKeyWith(obj, key, {});
}

function resolveArrayKey(obj, key) {
  return resolveKeyWith(obj, key, []);
}

function resolveKeyWith(obj, key, valueIfUndefined) {
  var value = obj[key];
  if (value === undefined) {
    value = valueIfUndefined;
    obj[key] = value;
  }
  return value;
}

function arrayKeyCheck(key) {
  // Regex for determine whether a str is a array representation.
  // For example 'prop[2]' will be considered as an array with property name prop and index 2.
  var arrayIndexRegex = /(.+)\[(\d+)\]/;

  var match = key.match(arrayIndexRegex),
    isArray = !!match,
    arrayCheck = { isArray: isArray };

  if (isArray) {
    arrayCheck.key = match[1];
    arrayCheck.index = match[2];
  }

  return arrayCheck;
}

function isFunction(value) {
  return value !== null && typeof value === 'function';
}

function isArray(value) {
  return Array.isArray(value);
}

function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}

function isString(value) {
  return typeof value === 'string';
}

function parseConnectTypes(body, currentTypes) {
  let shouldAssign = false;
  let recivedTypes = [];
  Object.keys(CONNECT_TYPES_MAP).map(key => {
    if (body[CONNECT_TYPES_MAP[key]] !== undefined) {
      shouldAssign = true;
      if (!body[CONNECT_TYPES_MAP[key]]) {
        recivedTypes.push(key);
      } else {
        currentTypes = currentTypes.filter(type => type !== key);
      }
      delete body[CONNECT_TYPES_MAP[key]];
    }
  });
  if (shouldAssign) {
    body['connect_networks'] = union(recivedTypes, currentTypes);
  }
  return body;
}

export default { map, parseConnectTypes };
export { map as autoMapper };
